// src/pages/ProfilePage.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Paper, Box, Button, Divider } from '@mui/material';
import { getExamHistory } from '../utils/quizUtils';

const HistoryPage = () => {
    const [examHistory, setExamHistory] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch the history from local storage on component mount
        setExamHistory(getExamHistory());
    }, []);

    // Navigate to the setup page to retake a specific quiz
    const handleRetakeQuiz = (sourceFiles) => {
        if (!sourceFiles || sourceFiles.length === 0) {
            alert("This quiz was generated from a search or dynamic source and cannot be retaken directly.");
            return;
        }
        navigate('/quiz-setup', { state: { selectedFiles: sourceFiles } });
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                My Exam History
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                A record of quizzes taken on this device.
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {examHistory.length === 0 ? (
                <Paper sx={{ p: 4, textAlign: 'center' }} variant="outlined">
                    <Typography variant="h6" color="text.secondary">
                        You have not completed any quizzes yet.
                    </Typography>
                    <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/')}>
                        Take a Quiz
                    </Button>
                </Paper>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* Reverse the array to show the most recent exams first */}
                    {[...examHistory].reverse().map((exam, index) => (
                        <Paper
                            key={index}
                            elevation={2}
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, row on desktop
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 2,
                            }}
                        >
                            <Box sx={{ flexGrow: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                                <Typography variant="h6">{exam.title}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Completed: {new Date(exam.dateCompleted).toLocaleDateString()} at {new Date(exam.dateCompleted).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </Typography>
                            </Box>
                            
                            <Box sx={{ textAlign: 'center', minWidth: '100px' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                    {exam.score} / {exam.totalQuestions}
                                </Typography>
                                <Typography variant="caption" display="block">
                                    Score
                                </Typography>
                            </Box>

                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleRetakeQuiz(exam.sourceFiles)}
                                // Disable the button if the quiz has no source files (e.g., from a search result).
                                disabled={!exam.sourceFiles || exam.sourceFiles.length === 0}
                            >
                                Retake
                            </Button>
                        </Paper>
                    ))}
                </Box>
            )}
        </Container>
    );
};

export default HistoryPage;
